import { LibraryState } from './index';

export const selectPcapFiles = (state: { library: LibraryState }) => state.library.pcapFiles;
export const selectGetPcapFilesStatus = (state: { library: LibraryState }) => state.library.getPcapFilesStatus;
export const selectGetPcapFilesError = (state: { library: LibraryState }) => state.library.getPcapFilesError;
export const selectPcapFilesCount = (state: { library: LibraryState }) => state.library.pcapFilesCount;
export const selectDownloadPcapFileError = (state: { library: LibraryState }) => state.library.downloadPcapFileError;
export const selectDownloadPcapFileStatus = (state: { library: LibraryState }) => state.library.downloadPcapFileStatus;
